var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Store, Mutation } from './annotations';
import { getInitialToastState } from '@pjn/core/ui/state/notification';
const getMethod = (quiet) => (quiet ? 'showQuiet' : 'show');
/**
 * Store que guarda y administra el estado centralizado de las notificaciones de la App (Snacks)
 */
let NotificationStore = class NotificationStore extends Vue {
    constructor() {
        super(...arguments);
        /** Estado de notificacion */
        this.status = getInitialToastState();
    }
    error(message, props = {}) {
        this[getMethod(props.quiet)]({ message, type: 'error', duration: props.duration, style: props.style });
    }
    info(message, props = {}) {
        this[getMethod(props.quiet)]({ message, type: 'information', duration: props.duration, style: props.style });
    }
    warn(message, props = {}) {
        this[getMethod(props.quiet)]({ message, type: 'warning', duration: props.duration, style: props.style });
    }
    showQuiet(notification) {
        this.status = { ...notification, show: true };
    }
    show(notification) {
        this.showQuiet(notification);
    }
    hideQuiet() {
        this.status = { ...getInitialToastState(), style: this.status.style };
    }
    hide() {
        this.hideQuiet();
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NotificationStore.prototype, "show", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], NotificationStore.prototype, "hide", null);
NotificationStore = __decorate([
    Store
], NotificationStore);
export { NotificationStore };
//# sourceMappingURL=NotificationStore.js.map